import API_ROUTES from "../constants/api";
import { DEFAULT_ITEMS_PER_PAGE } from "../constants/common";
import HttpUtil from "../http-handler/http-util";

export default class IncidentTypeService {
  static getList(pageNumber = 0, pageSize = DEFAULT_ITEMS_PER_PAGE, key='') {
    return HttpUtil.get(API_ROUTES.INCIDENTTYPES.LIST.replace("<pageNumber>", pageNumber)
    .replace("<pageSize>", pageSize)
    .replace("<key>", key));
  }

  static onSubmit(id,params) {
    var url = API_ROUTES.INCIDENTTYPES.SUBMIT;
    if(id!=null && id!=="") {
        url+='/'+id;
        return HttpUtil.put(url,params);  
    } else {        
        return HttpUtil.post(url,params);  
    }  
  }

//   static deleteData(encodedUrlParam,id) {
//     var url = API_ROUTES.COUNTRYSCORE.DELETE.replace("<encodedUrlParam>", encodedUrlParam)
//     .replace("<id>", id);
//     return HttpUtil.delete(url);    
//   }
 
}